import { Controller } from "@hotwired/stimulus";
import moment from "moment";

export default class extends Controller {
  static targets = ["originalInput", "dateInput", "timeInput", "otherDay", "today", "tomorrow"];

  connect() {
    this.syncHelperInputs();
    this.showAndHideDateInput();
  }

  today() {
    this.showOtherDayInput(false);
    const sameTimeToday = this.momentForDate(0);
    this.updateInput(sameTimeToday);
  }

  tomorrow() {
    this.showOtherDayInput(false);
    const sameTimeTomorrow = this.momentForDate(1);
    this.updateInput(sameTimeTomorrow);
  }

  onOtherDayClick() {
    this.showOtherDayInput(true);
  }

  onTimeChange(event) {
    const newTime = moment(event.currentTarget.value, "HH:mm");

    const sameDateDifferentTime = this.currentMoment().set({
      minute: newTime.get("minute"),
      hour: newTime.get("hour"),
      second: newTime.get("second")
    });

    this.updateInput(sameDateDifferentTime);
  }

  onDateChange(event) {
    const newDate = moment(event.currentTarget.value);

    const sameTimeDifferentDate = this.currentMoment().set({
      year: newDate.get("year"),
      month: newDate.get("month"),
      date: newDate.get("date")
    });

    this.updateInput(sameTimeDifferentDate);
  }

  showOtherDayInput(show) {
    if (show) {
      this.otherDayTarget.classList.add("hidden");
      this.dateInputTarget.classList.remove("hidden");
    } else {
      this.otherDayTarget.classList.remove("hidden");
      this.dateInputTarget.classList.add("hidden");
    }
  }

  updateInput(moment) {
    this.originalInputTarget.value = moment.format("YYYY-MM-DDTHH:mm");

    this.originalInputTarget.dispatchEvent(new Event("change", {
      bubbles: true,
      cancelable: true,
    }));

    this.syncHelperInputs();
  }

  syncHelperInputs() {
    const currentMoment = this.currentMoment();
    this.timeInputTarget.value = currentMoment.format("HH:mm");

    this.dateInputTarget.value = currentMoment.format("YYYY-MM-DD");

    const date = this.currentMoment().format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    const tomorrow = moment()
      .add(1, "day")
      .format("YYYY-MM-DD");

    const activeClasses = ["bg-blue", "text-white"];

    this.todayTarget.classList.remove(...activeClasses);
    this.tomorrowTarget.classList.remove(...activeClasses);

    if (date === today) {
      this.todayTarget.classList.add(...activeClasses);
    } else if (date === tomorrow) {
      this.tomorrowTarget.classList.add(...activeClasses);
    }
  }

  showAndHideDateInput() {
    const date = this.currentMoment().format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    const tomorrow = moment()
      .add(1, "day")
      .format("YYYY-MM-DD");

    if (date === today) {
      this.showOtherDayInput(false);
    } else if (date === tomorrow) {
      this.showOtherDayInput(false);
    } else {
      this.showOtherDayInput(true);
    }
  }

  momentForDate(daysInTheFuture = 0) {
    const future = moment().add(daysInTheFuture, "days");
    return this.currentMoment().set({
      year: future.year(),
      month: future.month(),
      date: future.date()
    });
  }

  currentMoment() {
    return moment(this.originalInputTarget.value);
  }
}
